var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17 5.66732C13.8704 5.66732 11.3333 8.20437 11.3333 11.334C11.3333 14.4635 13.8704 17.0007 17 17.0007C20.1296 17.0007 22.6667 14.4635 22.6667 11.334C22.6667 8.20437 20.1296 5.66732 17 5.66732ZM8.5 11.334C8.5 6.63956 12.3056 2.83398 17 2.83398C21.6944 2.83398 25.5 6.63956 25.5 11.334C25.5 16.0284 21.6944 19.834 17 19.834C12.3056 19.834 8.5 16.0284 8.5 11.334ZM11.3333 25.5007C8.98613 25.5007 7.08333 27.4034 7.08333 29.7507C7.08333 30.5331 6.44906 31.1673 5.66667 31.1673C4.88427 31.1673 4.25 30.5331 4.25 29.7507C4.25 25.8387 7.42132 22.6673 11.3333 22.6673H22.6667C26.5786 22.6673 29.75 25.8387 29.75 29.7507C29.75 30.5331 29.1158 31.1673 28.3333 31.1673C27.5509 31.1673 26.9167 30.5331 26.9167 29.7507C26.9167 27.4034 25.0139 25.5007 22.6667 25.5007H11.3333Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.ff6bbe4d6bc8c656927f946299ee0b7a.svg";
export { ForwardRef as ReactComponent };